import { render, staticRenderFns } from "./CustomerContactDots.vue?vue&type=template&id=1b5621cc&scoped=true&"
import script from "./CustomerContactDots.vue?vue&type=script&lang=js&"
export * from "./CustomerContactDots.vue?vue&type=script&lang=js&"
import style0 from "./CustomerContactDots.vue?vue&type=style&index=0&id=1b5621cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5621cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VList,VListItem,VListItemTitle,VMenu})
